import { forwardRef, isValidElement, cloneElement, Children } from "react";
import Flex from "../flex";
import { useControllableState } from "../../hooks";
import VisualMenuItem from "./visual-menu-item";
import { jsx as _jsx } from "react/jsx-runtime";
export const VisualMenu = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    selectedKeys,
    defaultSelectedKeys,
    onSelect,
    orientation = "horizontal",
    itemWidth,
    itemHeight = 40,
    color,
    children,
    ...rest
  } = _ref;
  const [currentKeys, setCurrentKeys] = useControllableState(selectedKeys, onSelect, defaultSelectedKeys ?? []);
  const direction = orientation === "vertical" ? "column" : "row";
  const items = Children.map(children, child => {
    if ( /*#__PURE__*/isValidElement(child)) {
      const {
        eventKey
      } = child.props;
      return /*#__PURE__*/cloneElement(child, {
        orientation: orientation,
        width: itemWidth,
        height: itemHeight,
        selected: currentKeys.includes(eventKey),
        onSelect: () => setCurrentKeys([eventKey])
      });
    }
    return child;
  });
  return /*#__PURE__*/_jsx(Flex, {
    ref: ref,
    flexDirection: direction,
    ...rest,
    color: color,
    children: items
  });
});
export default Object.assign(VisualMenu, {
  Item: VisualMenuItem
});